module.exports = __webpack_public_path__ + "img/cg-logo.bc0fc646.png";